import React from 'react';

export const Logo = ({ height = 60 }) => {
  return (
    <svg width={height * 4} height={height} viewBox="0 0 240 60" xmlns="http://www.w3.org/2000/svg">
      {/* Background Shield */}
      <defs>
        <linearGradient id="shieldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#4ECDC4', stopOpacity: 0.3 }} />
          <stop offset="100%" style={{ stopColor: '#4ECDC4', stopOpacity: 0.1 }} />
        </linearGradient>
      </defs>
      
      {/* Shield Shape */}
      <path 
        d="M30 8 L45 12 L45 28 C45 38 38 44 30 48 C22 44 15 38 15 28 L15 12 Z" 
        fill="url(#shieldGrad)" 
        stroke="#4ECDC4" 
        strokeWidth="2"
      />
      
      {/* Letter A in Shield */}
      <path 
        d="M30 17 L36 34 L33.5 34 L32 30 L28 30 L26.5 34 L24 34 Z M28.5 27.5 L31.5 27.5 L30 20.5 Z" 
        fill="#4ECDC4"
        stroke="#4ECDC4"
        strokeWidth="0.5"
      />
      
      {/* Handshake Icon - More realistic */}
      {/* Left arm (golden/beige) */}
      <path 
        d="M18 39 L18 37 L22 37 L24 35 L26 35 L26 37 L24 39 Z" 
        fill="#F0C48C" 
        stroke="#D4A574" 
        strokeWidth="0.8"
      />
      
      {/* Right arm (blue/gray) */}
      <path 
        d="M42 39 L42 37 L38 37 L36 35 L34 35 L34 37 L36 39 Z" 
        fill="#95C4D1" 
        stroke="#7BA7B5" 
        strokeWidth="0.8"
      />
      
      {/* Left hand握手部分 */}
      <ellipse 
        cx="26" 
        cy="37" 
        rx="2.5" 
        ry="2" 
        fill="#F7D4A8" 
        stroke="#D4A574" 
        strokeWidth="0.5"
      />
      
      {/* Right hand握手部分 */}
      <ellipse 
        cx="34" 
        cy="37" 
        rx="2.5" 
        ry="2" 
        fill="#B8D8E6" 
        stroke="#7BA7B5" 
        strokeWidth="0.5"
      />
      
      {/* Handshake connection/overlap */}
      <ellipse 
        cx="30" 
        cy="37" 
        rx="3" 
        ry="2.2" 
        fill="#FFFFFF" 
        opacity="0.7"
      />
      
      {/* Thumb details */}
      <circle cx="26" cy="35.5" r="1" fill="#F0C48C" stroke="#D4A574" strokeWidth="0.3"/>
      <circle cx="34" cy="35.5" r="1" fill="#95C4D1" stroke="#7BA7B5" strokeWidth="0.3"/>
      
      {/* Text: ApkaDostCA */}
      <text 
        x="58" 
        y="30" 
        fontFamily="'Segoe UI', Arial, sans-serif" 
        fontSize="22" 
        fontWeight="700" 
        fill="#FFFFFF"
      >
        Apka<tspan fill="#4ECDC4">Dost</tspan>CA
      </text>
      
      {/* Tagline */}
      <text 
        x="58" 
        y="45" 
        fontFamily="'Segoe UI', Arial, sans-serif" 
        fontSize="11" 
        fill="#95A5A6" 
        fontWeight="400"
      >
        Your Financial Companion
      </text>
    </svg>
  );
};

export default Logo;

